import axios from 'axios';

export function getACAReport(vin, reportType, config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };

  const args = `?VIN=${vin}&reportType=${reportType}`;
  const url = config.acaReportManageService + args;
  return dispatch => dispatch({
    type: 'ACA_REPORT_FETCH',
    payload: axios({ method: 'post', url, headers })
  }).catch((error) => {
    console.log(error);
  });
}

export function clearACAReport() {
  return {
    type: 'ACA_REPORT_CLEAR',
    payload: ''
  };
}



// WEBPACK FOOTER //
// ./src/actions/getACAReport.js